// Mui
import { Box, Theme } from '@mui/material';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectNewDesignEnabled, selectIsPageSelected } from 'app/store/pagesToolbar/pagesToolbar.selectors';

type Props = {
  documentId: number;
  pageNum: number;
}

const PageSelectHighlight = ({ documentId, pageNum }:Props) => {
  // State
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);
  const isPageSelected = useAppSelector((state:any) => selectIsPageSelected(state, {
    documentId,
    pageNum
  }));

  if ( !newDesignEnabled || !isPageSelected ) return null;
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0, right: 0, bottom: 0, left: 0,
        bgcolor: (theme:Theme) => theme.palette.primary.light,
        border: (theme:Theme) => `2px solid ${theme.palette.grey[900]}`,
        borderRadius: 1,
        m: '-1px',
        pointerEvents: 'none'
      }}
    />
  )
}

export default PageSelectHighlight